(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("FrameworkGeneratorCode", [], factory);
	else if(typeof exports === 'object')
		exports["FrameworkGeneratorCode"] = factory();
	else
		root["FrameworkGeneratorCode"] = factory();
})(typeof self !== 'undefined' ? self : this, function() {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition